<template>
  <div class="grid grid-cols-1 items-center" data-qa="prices">
    <slot name="current">
      <PriceCurrent
        data-qa="price"
        data-test="price"
        :price="price.display"
        :size="size"
      />
    </slot>
    <div v-if="isDisplayedOriginalPrice" class="m-3">
      <slot name="original">
        <PriceOriginal
          data-test="original"
          :price="originalPrice.display"
          :size="size"
        />
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import PriceCurrent from './PriceCurrent.vue'
import PriceOriginal from './PriceOriginal.vue'
import { type PricesProps } from './types'

const props = withDefaults(defineProps<PricesProps>(), {})

const isDisplayedOriginalPrice = computed(() => {
  const originalPriceValue = props.originalPrice.raw
  const priceValue = props.price.raw

  return !Number.isNaN(originalPriceValue) && priceValue < originalPriceValue
})
</script>
